export const PlatformUtility = {
  isOnClient: () => {
    // window and window.document (the DOM) only exist in client
    return !!(typeof window !== 'undefined' && window.document);
  }
};
